import { createObserver } from "./utils/createObserver.js";
function observe(element, onChange, options = {}, fallbackInView = void 0) {
  if (!window.IntersectionObserver && typeof fallbackInView === "boolean") {
    const bounds = element.getBoundingClientRect();
    onChange(fallbackInView, {
      boundingClientRect: bounds,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      intersectionRect: bounds,
      isIntersecting: fallbackInView,
      rootBounds: bounds,
      target: element,
      time: 0
    });
    return function unobserve() {
    };
  }
  const { observer, elements, removeFromCache } = createObserver(options);
  elements.set(element, elements.get(element) ?? []);
  elements.get(element)?.push(onChange);
  observer.observe(element);
  return function unobserve() {
    const index = elements.get(element)?.indexOf(onChange) ?? -1;
    if (index > -1) elements.get(element)?.splice(index, 1);
    if (elements.get(element)?.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      removeFromCache();
    }
  };
}
export {
  observe
};
//# sourceMappingURL=observe.js.map
